/**
 * Splits text into sentences based on sentence-ending punctuation.
 * Handles periods, exclamation marks, and question marks.
 *
 * @param text - The text to split into sentences
 * @returns An array of sentences (trimmed and non-empty)
 *
 * @example
 * splitIntoSentences("Explanation was good. Example provided correctly.")
 * // Returns: ["Explanation was good.", "Example provided correctly."]
 */
export const splitIntoSentences = (text: string): string[] => {
  if (!text || text.trim().length === 0) {
    return [];
  }
  // Split by sentence-ending punctuation (. ! ?) followed by space or end of string
  // Match sentences ending with . ! or ? followed by space or end of string
  const sentences = text
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return sentences;
};
